import React, {Component} from 'react';

class PopupTooltip extends Component{

    constructor(props){
        super(props);
        this.state = {
            isHovered: false
        }
    }

    onHoverEnter = () => {
        this.setState({
            ...this.state,
            isHovered: true
        })
    };

    onHoverLeave = () => {
        this.setState({
            ...this.state,
            isHovered: false
        })
    };

    render(){
        const {children, label, customStyle} = this.props;
        return (
            <div
                onMouseEnter={this.onHoverEnter}
                onMouseLeave={this.onHoverLeave}
                className={customStyle?customStyle:'popup-tooltip'}
            >
                {children}
                {this.state.isHovered && (
                    <div className="popup-tooltip__info-box">
                        <div>{label}</div>
                    </div>
                )}
            </div>
        )
    }
}

export default PopupTooltip;